import React from 'react';
import { Route } from 'react-router-dom';
import SellerLayout from '../views/Seller/SellerLayout';
import SellerDashboard from '../views/Seller/SellerDashboard';

const sellerRoutes = (
  <Route path="/seller" element={<SellerLayout />}>
    <Route index element={<SellerDashboard />} />
  </Route>
);

export default sellerRoutes;
